export default __webpack_public_path__ + "static/media/prevDate.e0fdb03a.svg";